import React, {
  useEffect,
  useState,
} from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";

import Header from "./components/Header";

import Footer from "./components/Footer";

import Dashboard from "./Pages/Dashboard";

import Products from "./Pages/Products";

import Customers from "./Pages/Customers";

import Reports from "./Pages/Reports";

import Promotions from "./Pages/Promotionsmanager";

import SalesHistory from "./Pages/SalesHistory";

import PromotionDetails from "./components/PromotionDetails";

import LoyaltyPointsPage from "./Pages/LoyaltyPointsPage";

import LoyaltyStats from "./components/LoyaltyStats";

import Ferrypass from "./Pages/Ferrypass";

import CashForCashStatement from "./Pages/CashForCashStatement";

import Balances from "./Pages/Balances";

import PromotionPrize from "./Pages/PromotionPrize";

import UserManagement from "./Pages/UserManagement";

import FirstChangePassword from "./Pages/FirstChangePassword";

import Login from "./Pages/Login";

import {
  ToastContainer,
} from "react-toastify";

import {
  ConfirmProvider,
} from "./contexts/ConfirmContext";

import "react-toastify/dist/ReactToastify.css";

/* ========================================
   SIMPLE AUTH CHECK
======================================== */

const isLoggedIn = () => {

  const raw =
    localStorage.getItem(
      "rcs_pos_auth"
    );

  if (!raw) return false;

  try {

    const auth =
      JSON.parse(raw);

    const TWENTY_FOUR_HOURS =
      24 * 60 * 60 * 1000;

    const expired =
      Date.now() -
        auth.loginTime >
      TWENTY_FOUR_HOURS;

    if (expired) {

      localStorage.removeItem(
        "rcs_pos_auth"
      );

      return false;
    }

    return auth.loggedIn === true;

  } catch {

    return false;

  }

};
/* ========================================
   LAYOUT
======================================== */

function Layout({
  children,
}) {

  const location =
    useLocation();

  const navigate =
    useNavigate();

  const isAuthScreen =
    location.pathname ===
      "/login" ||
    location.pathname ===
      "/change-password";

  /* ========================================
     SIMPLE PROTECTION
  ======================================== */

  useEffect(() => {

    if (
      !isAuthScreen &&
      !isLoggedIn()
    ) {

      navigate(
        "/login"
      );

    }

  }, [
    isAuthScreen,
    navigate,
  ]);

  return (
    <div className="app-container">

      {/* HEADER */}

      {!isAuthScreen && (
        <Header />
      )}

      {/* CONTENT */}

      {children}

      {/* TOAST */}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
      />

      {/* FOOTER */}

      {!isAuthScreen && (
        <Footer />
      )}
    </div>
  );
}

/* ========================================
   APP INNER
======================================== */

function AppInner() {

  const [searchTerm, setSearchTerm] =
    useState("");

  const [cart, setCart] =
    useState([]);

  const addToCart =
    (product) => {

      setCart([
        ...cart,
        {
          ...product,
          quantity: 1,
        },
      ]);

    };

  return (
    <Layout>

      <Routes>

        {/* LOGIN */}

        <Route
          path="/login"
          element={
            isLoggedIn()
              ? (
                <Navigate
                  to="/"
                  replace
                />
              )
              : (
                <Login />
              )
          }
        />

        {/* DASHBOARD */}

        <Route
          path="/"
          element={
            <Dashboard
              cart={cart}
              setCart={setCart}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              addToCart={addToCart}
            />
          }
        />

        {/* CUSTOMERS */}

        <Route
          path="/customers"
          element={
            <Customers />
          }
        />

        {/* SALES */}

        <Route
          path="/sales-history"
          element={
            <SalesHistory />
          }
        />

        {/* BALANCES */}

        <Route
          path="/balances"
          element={
            <Balances />
          }
        />

        {/* PRODUCTS */}

        <Route
          path="/products"
          element={
            <Products
              cart={cart}
              setCart={setCart}
              searchTerm={searchTerm}
              addToCart={addToCart}
            />
          }
        />

        {/* REPORTS */}

        <Route
          path="/reports"
          element={<Reports />}
        />

        {/* PROMOTIONS */}

        <Route
          path="/promotions"
          element={<Promotions />}
        />

        <Route
          path="/promotions/prize"
          element={
            <PromotionPrize />
          }
        />

        <Route
          path="/promotions/:id"
          element={
            <PromotionDetails />
          }
        />

        {/* LOYALTY */}

        <Route
          path="/loyalty"
          element={
            <LoyaltyPointsPage />
          }
        />

        <Route
          path="/loyalty/:id"
          element={
            <LoyaltyStats />
          }
        />

        {/* FERRYPASS */}

        <Route
          path="/ferrypass"
          element={<Ferrypass />}
        />

        {/* CASH STATEMENT */}

        <Route
          path="/cash-statement"
          element={
            <CashForCashStatement />
          }
        />

        {/* USERS */}

        <Route
          path="/admin/users"
          element={
            <UserManagement />
          }
        />

        {/* PASSWORD */}

        <Route
          path="/change-password"
          element={
            <FirstChangePassword />
          }
        />

        {/* FALLBACK */}

        <Route
          path="*"
          element={
            <Navigate
              to={
                isLoggedIn()
                  ? "/"
                  : "/login"
              }
              replace
            />
          }
        />

      </Routes>
    </Layout>
  );
}

/* ========================================
   MAIN APP
======================================== */

export default function App() {

  return (
    <ConfirmProvider>

      <Router>
        <AppInner />
      </Router>

    </ConfirmProvider>
  );
}